import type { ProfileBranding } from "../viewmodel/buildViewModel";
import type { BrandTokens } from "./tokens";

/**
 * ProfileBrandingHeader — renders the org logo + contact as part of a template
 * (contact left, logo right). Shared across templates so each can place/skin it;
 * for now it's a simple header row. Fed from vm.branding + tokens.
 */
export function ProfileBrandingHeader({
  branding,
  tokens,
}: {
  branding: ProfileBranding;
  tokens: BrandTokens;
}) {
  const { contact, logoUrl, organizationName } = branding;
  const hasContact = !!(contact.name || contact.email || contact.phone);

  if (!hasContact && !logoUrl) return null;

  return (
    <div
      className="mb-8 flex flex-row items-center justify-between"
      style={{
        borderBottom: `1px solid ${tokens.colors.line}`,
        paddingBottom: 12,
      }}
    >
      <div className="text-xs" style={{ color: tokens.colors.muted }}>
        {contact.name && (
          <p className="font-semibold" style={{ color: tokens.colors.text }}>
            {contact.name}
          </p>
        )}
        {contact.email && <p>{contact.email}</p>}
        {contact.phone && <p>{contact.phone}</p>}
      </div>
      {logoUrl && (
        <img
          src={logoUrl}
          alt={organizationName ?? "logo"}
          className="object-scale-contain"
          style={{ maxHeight: 50 }}
        />
      )}
    </div>
  );
}
